<template>
  <div class="form-group" :class="{ 'has-danger' : errors.has(name) }">
    <div class="has-float-label">
      <input :style="styler" type="text" class="form-control" :id="name" :name="name" v-bind:value="value" :ref="name" v-validate="validation" v-on:input="onInput" :placeholder="placeholder ? placeholder : label" :readonly="readonly">
      <label :for="name">{{label}}</label>
      <div class="form-control-feedback" v-if="errors.has(name)">{{ errors.first(name) }}</div>
    </div>
  </div>
</template>

<script>
//TypeError: "can't convert undefined to object" is caused by validation being null

export default {
  props: {
    label: String,
    value: String,
    placeholder: String,
    readonly: String,
    name: String,
    styler: {
      default:''
    },
    validation:{
      default: ''
    }
  },
  methods: {
    onInput (event) {
      this.$emit('input', event.target.value)
    }
  }
}
</script>


// WEBPACK FOOTER //
// FormText.vue?57ee39a2